const API_MAP = {
  ADMIN_API: {
    path: "clarity/api/manage",
    legacy: `${process.env.REACT_APP_ADMIN_API}`,
  },
  BRAIN_API: {
    path: "brain/api",
    legacy: `${process.env.REACT_APP_BRAIN_API}`,
  },
  CLARITY_API: {
    path: "clarity/api",
    legacy: `${process.env.REACT_APP_CLARITY_API}`,
  },
  IDEM_API: {
    path: "idem",
    legacy: `${process.env.REACT_APP_IDEM_API}`,
  },
  INTEGRATIONS_API: {
    path: "integrations/api",
    legacy: `${process.env.REACT_APP_INTEGRATIONS_API}`,
  },
  JIRA_MANAGEMENT_API: {
    path: "jira-management",
    legacy: `${process.env.REACT_APP_JIRA_MANAGEMENT_API}`,
  },
  PENTEST_API: {
    path: "pentest/api/manage",
    legacy: `${process.env.REACT_APP_PENTEST_API}`,
  },
  PENTEST_API_CLARITY: {
    path: "pentest/api",
    legacy: `${process.env.REACT_APP_PENTEST_API_CLARITY}`,
  },
  PHISH_API_V2: {
    path: "phish-v2/api/manage",
    legacy: `${process.env.REACT_APP_PHISH_API_V2}`,
  },
  QUERY_ENGINE_API: {
    path: "query-engine/api",
    legacy: `${process.env.REACT_APP_QUERY_ENGINE_API}`,
  },
  REPORTING_API: {
    path: "reporting/api",
    legacy: `${process.env.REACT_APP_REPORTING_API}`,
  },
  SERVICE_DELIVERY_API: {
    path: "service-delivery/api/manage",
    legacy: `${process.env.REACT_APP_SERVICE_DELIVERY_API}`,
  },
  SOC_API: {
    path: "soc/api/manage",
    legacy: `${process.env.REACT_APP_SOC_API}`,
  },
  USER_API: {
    path: "api/user",
    legacy: `${process.env.REACT_APP_USER_API}`,
  },
  VULN_API: {
    path: "vuln/api/manage",
    legacy: `${process.env.REACT_APP_VULN_API}`,
  },
};

const API_URL_OVERRIDES = {
  // SOC_API: "http://localhost:7071/api/clarity",
  // CLARITY_API: "http://localhost:7071/api",
  // ADMIN_API: "http://localhost:7071/api/manage",
};

export const getApiUrl = (api) => {
  // Only when running in dev mode, check if there are any overrides
  if (process.env.NODE_ENV === "development") {
    if (API_URL_OVERRIDES[api]) return API_URL_OVERRIDES[api];
  }

  const baseUrl = localStorage.getItem("regionBaseUrl");
  if (API_MAP[api] === undefined) {
    throw new Error(`Invalid key name - ${api}`);
  }
  const apiAddOn = API_MAP[api].path;
  return baseUrl ? `${baseUrl}/${apiAddOn}` : API_MAP[api].legacy;
};
